<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container mail-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="'Reminder!'"
>
  <div class="main-content" *ngIf="!isEdit">
    <div>
      <div class="subject">
        Subject:Friendly Reminder: Design Change Assessment Submission Due Soon
      </div>
      <div class="email_box">
        <div class="greeting">Dear [First Name] [Last Name],</div>
        <div class="email-description">
          I hope you’re doing well.<br /> This is a gentle reminder to complete and
          submit your response to the Design Change Assessment.<br /> You can access
          the RIA platform and submit your response using the link below: 👉
          [Platform Link] Please note that your due date [DDMMYYYY] is
          approaching. <br /> You have [2 days – 1 Day] remaining to submit your
          response. If no response is received by the due date, it will be
          considered as 'No Impact'.<br /> If you have any questions regarding the
          Design Change Assessment, please don’t hesitate to reach out.
        </div>
      </div>
      <div class="signature">
        <div class="regards">Regards,</div>
        <p>
          [Change Initiated User First Name] [Change initiated User Last Name]
        </p>
        <p>Bayer Radiology Regulatory Team</p>
      </div>
    </div>
  </div>
  <div *ngIf="isEdit">
    <form action="" [formGroup]="emailForm">
      <div class="edit-form">
        <div class="flex flex-col gap-3">
          <label for="subject">Subject:</label>
          <input
            pInputText
            id="subject"
            formControlName="custom_subject"
            aria-describedby="subject-help"
            placeholder="Enter Subject"
            [ngClass]="{
              'ng-invalid ng-dirty':
                emailForm.controls['custom_subject'].invalid &&
                (emailForm.controls['custom_subject'].touched ||
                  emailForm.controls['custom_subject'].dirty)
            }"
          />
        </div>
        <div class="flex flex-col gap-3 mt-3">
          <label for="dear">Dear</label>
          <textarea
            rows="5"
            cols="10"
            pTextarea
            for="dear"
            formControlName="custom_body"
            placeholder="Enter email"
            class="custom-textarea"
            [ngClass]="{
              'ng-invalid ng-dirty':
                emailForm.controls['custom_body'].invalid &&
                (emailForm.controls['custom_body'].touched ||
                  emailForm.controls['custom_body'].dirty)
            }"
          ></textarea>
        </div>
        <div class="signature mt-3">
          <div class="regards">Regards,</div>
          <p>RCA Platform Notification System</p>
          <p>Bayer Radiology Regulatory Team</p>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      *ngIf="!isEdit"
      [label]="'Edit'"
      [styleClass]="'p-button-secondary p-button-edit p-button-text'"
      (onClick)="onEdit()"
    ></p-button>
    <p-button
      *ngIf="isEdit"
      [label]="'Cancel'"
      [styleClass]="'p-button-secondary p-button-edit p-button-text'"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      [label]="'Send'"
      [styleClass]="'p-button-primary p-button-send'"
      [disabled]="isEdit ? emailForm.invalid : false"
      (onClick)="onSend()"
    ></p-button>
  </ng-template>
</p-dialog>
